module.exports = __webpack_public_path__ + "static/ELBA_Areal_Aufgabenstellung_Realisierungsphase-1b9b113c9e13d1bd409293971c38dcfe.pdf";